// skeleton/TableSkeleton.js
import React from "react";

const CommonTableSkeleton = ({ columns, rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <tr key={rowIdx} className="border-b animate-pulse">
          {columns.map((col) => (
            <td key={col.name} className="p-2 max-w-[180px]">
              {/* Skeleton for avatar */}
              {col.name === "avatar" ? (
                <div className="w-8 h-8 rounded-full bg-gray-300 mx-auto" />
              ) : // Skeleton for status/role/user_type pills
              col.name === "status" ||
                col.name === "role" ||
                col.name === "user_type" ? (
                <div className="h-4 w-16 bg-gray-300 rounded-full mx-auto" />
              ) : (
                // Skeleton for normal text
                <div className="h-4 bg-gray-300 rounded w-full" />
              )}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default CommonTableSkeleton;
